<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">
          <span v-if="is_vod_event">{{ $t('vod.list.card.title') }}</span>
          <span v-else>{{ $t('screener.title') }}</span>
          </div>
        <span v-if="is_vod_event" class="body-1 greyDarken1--text">{{$t('vod.list.card.subtitle')}}</span>
        <span v-else class="body-1 greyDarken1--text">{{$t('screener.list.subtitle')}}</span>
      </div>
      <v-spacer></v-spacer>
      <CreateScreener v-if="$route.name=='vod.list' || elaborateEventDialogue" :is_vod_event="is_vod_event" :dialog="elaborateEventDialogue"></CreateScreener>
      <v-menu v-else offset-y>
        <template slot="activator">
          <!-- <v-btn fab dark color="cyan">
            <img :src="`${publicPath}/assets/add-button.png`" height="30" width="30"/>
          </v-btn> -->
          <v-btn color="secondary" dark slot="activator">
            <v-icon small>$vuetify.icons.rms_create</v-icon>
            {{ $t("rms.button.create") }}
          </v-btn>
        </template>
        <v-list>
          <v-list-tile @click="() => $router.push({name:'screener.quick.events'})">
            <v-list-tile-title>{{ $t('screener.list.page.create.menu.option.quick.event') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="() => $router.push({name:'screener.list', query: { createvent: 'elaborate' }})">
            <v-list-tile-title>{{ $t('screener.list.page.create.menu.option.elaborate.event') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

    </v-card-title>
    <v-card-text>
      <v-card>
        <v-card-title>
          <v-layout row wrap>
            <v-flex xs12 sm12 md4>
              <v-layout row wrap>
                <v-text-field
                  v-model="search"
                  prepend-inner-icon="search"
                  :label="$t('rms.files.search')"
                  single-line
                  color="primary"
                  hide-details
                  clearable
                  @click:clear="(search = ''), getApiData()"
                ></v-text-field>
                <v-btn
                  class="primary mt-3"
                  small
                  @click="search ? getApiData() : ''"
                  >{{ $t('rms.files.search') }}</v-btn
                >
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex v-if="!is_vod_event" xs12 sm12 md2>
              <v-select
                v-model="schedule_type"
                :items="DEFINES.SCREENING_SCHEDULE_TYPES"
                :label="$t('rms.screening_schedule_type')"
                item-text="text"
                item-value="value"
                @input="getApiData(true)"
                class="pr-2"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm12 md2>
              <!-- Event Plan Type -->
              <v-select
                v-model="screening_type"
                :items="DEFINES.SCREENING_TYPES"
                :label="$t('screener.overview.event_plan_type')"
                item-text="text"
                item-value="value"
                hide-details
                @input="getApiData()"
                class="pl-2"
              ></v-select>
            </v-flex>
             <v-flex xs12 sm12 md2>
              <!-- send event_types array for fetch multiple type events-->
              <v-select
                v-if='!is_vod_event'
                v-model="event_types"
                :items="eventTypes"
                :label="$t('screener.overview.event_type')"
                item-text="text"
                item-value="value"
                hide-details
                @input="getApiData()"
                class="pl-2"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-data-table
          :headers="table_headers"
          :items="list.data | EventType(is_vod_event ? DEFINES.EVENT_TYPE.VOD_EVENTS :DEFINES.EVENT_TYPE.STANDARD_EVENTS)"
          v-bind:pagination.sync="pagination"
          :total-items="total"
          :loading="loading"
          :rowsPerPageItems="[30, 50]"
        >
        <template slot="headers">
              <tr>
                <th class="text-xs-left">Reg. Link</th>
                <th class="text-xs-left">{{$t('screener.table.header.screener_id')}}</th>
                <th class="text-xs-left">{{$t('screener.table.header.title')}}</th>
                <th class="text-xs-left">{{$t('screener.overview.event_type')}}</th>
                <th class="text-xs-left">{{$t('screener.overview.event_plan_type')}}</th>
                <th class="text-xs-left" v-if="!is_vod_event">{{$t('screener.table.header.virtual_seats')}}</th>
                <th class="text-xs-left" v-if="!is_vod_event">{{$t('screener.table.header.venue_seats')}}</th>
                <th class="text-xs-left" v-if="!is_vod_event">{{$t('screener.table.header.start_end_date')}}</th>
                <th class="text-xs-left">{{$t('screener.table.header.status')}}</th>
                <th class="text-xs-left">{{$t('screener.table.header.monetize_type')}}</th>
                <!-- <th class="text-xs-left">{{$t('screener.table.header.action')}}</th> -->
            </tr>
        </template>
        <template v-slot:items="props">
            <tr
              :style="{cursor: 'pointer'}"
              @click.stop="viewScreener(props.item)"
            >
              <td @click.stop="copyRegistrationUrl(props.item.id)">
                <v-icon @click.stop="copyRegistrationUrl(props.item.id)" >mdi-link-variant</v-icon>
              </td>
              <td class="text-xs-left subheading">{{ props.item.id }}</td>
              <td class="text-xs-left">
                <v-tooltip top color="greyDarken1">
                  <template v-slot:activator="{on}">
                    <span v-on="on">{{ props.item.title | truncate }}</span>
                  </template>
                  <span class="white--text body-1">{{ props.item.title }}</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left"><v-chip
                class="success success--text font-weight-medium"
                small
                outline
                >{{  DEFINES.SCREENER_TYPE_STR[props.item.event_type] }}</v-chip
              ></td>
              <td>
                <div v-if="!props.item.is_vod_event">
                  <span
                    v-if="
                      props.item.screening_type ==
                        DEFINES.SCREENING_PLAN_TYPE.FREE
                    "
                    class="success--text"
                  >
                    <b>{{
                      DEFINES.SCREENING_PLAN_TYPE_STR[props.item.screening_type]
                    }}</b></span
                  >
                  <span
                    v-if="
                      props.item.screening_type ==
                        DEFINES.SCREENING_PLAN_TYPE.PREMIUM
                    "
                    class="blue--text"
                  >
                    <b>{{
                      DEFINES.SCREENING_PLAN_TYPE_STR[props.item.screening_type]
                    }}</b></span
                  >
                  <span
                    v-if="
                      props.item.screening_type ==
                        DEFINES.SCREENING_PLAN_TYPE.ENTERPRISE
                    "
                    class="orange--text"
                  >
                    <b>{{
                      DEFINES.SCREENING_PLAN_TYPE_STR[props.item.screening_type]
                    }}</b></span>
                </div>
                <span v-else>NA</span>


              </td>
              <td v-if="!is_vod_event" class="text-xs-left">
                <v-tooltip top color="greyDarken1">
                  <template v-slot:activator="{on}">
                    <span v-on="on">
                      {{ props.item.num_of_enrollments }}&nbsp;/&nbsp;{{
                        props.item.limitation
                      }}</span
                    >
                  </template>
                  <span class="white--text body-1">{{
                    $t('screener.total_registrants.tooltip')
                  }}</span>
                </v-tooltip>
              </td>
              <td v-if="!is_vod_event" class="text-xs-left">
                  {{props.item.venue_total_seats ? props.item.venue_total_seats : $t('screener.not_available.title')}}
              </td>
              <td v-if="!is_vod_event" class="text-xs-left">
                {{ fmtTime(props.item.screening_starts_at) }}
                (to)
                {{ fmtTime(props.item.screening_ends_at) }}
              </td>
              <td class="text-xs-left">
                <v-chip class="secondary secondary--text font-weight-medium" small outline>
                  {{ DEFINES.SCREENER_STATUS[props.item.published] }}
                </v-chip>
              </td>
              <td class="text-xs-left">
                <v-chip
                  v-if="isScreeningPaid(props.item)"
                  class="secondary secondary--text font-weight-medium"
                  small
                  outline
                  >{{ $t('screener.status.paid') }}</v-chip
                >
                <v-chip
                  v-else
                  class="secondary secondary--text font-weight-medium"
                  small
                  outline
                  >{{ $t('screener.status.free_to_audience') }}</v-chip
                >
              </td>
              <!-- <td class="text-xs-center">
                <v-tooltip slot="append" top color="white">
                  <v-btn
                    slot="activator"
                    icon
                    small
                    dark
                    @click.stop="viewScreener(props.item)"
                  >
                    <v-icon color="secondary"
                      >$vuetify.icons.rms_visibility</v-icon
                    >
                  </v-btn>
                  <span class="greyDarken3--text body-1">{{
                    $t('rms.tooltip.view')
                  }}</span>
                </v-tooltip>

                <v-tooltip slot="append" top color="white">
                  <v-btn
                    slot="activator"
                    icon
                    small
                    dark
                    @click.stop="deleteConfirmation(props.item.id)"
                  >
                    <v-icon color="secondary">$vuetify.icons.rms_delete</v-icon>
                  </v-btn>
                  <span class="greyDarken3--text body-1">{{
                    $t('rms.tooltip.delete')
                  }}</span>
                </v-tooltip>
              </td> -->
            </tr>
          </template>
        </v-data-table>
        <ConfirmationDialog
          :dialog="confirmation"
          @confirm="remove()"
          @cancel="confirmation = false"
        />
      </v-card>
    </v-card-text>
  </v-card>
</template>
<script>
import {mapState, mapGetters} from 'vuex';
import ConfirmationDialog from '@/components/dialogBox/Confirmation';
import i18n from '@/i18n';
import {utcToTz} from '@/helper';
import CreateScreener from './Create';
import DEFINES from "@/defines";
export default {
  name: 'ScreenerList',
  props: {
    is_vod_event: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_URL,
      search: '',
      schedule_type: 50,
      total: 0,
      confirmation: false,
      loading: true,
      event_types:[],
      table_headers: [
        {
          text: i18n.t('screener.table.header.screener_id'),
          align: 'left',
          sortable: false,
          value: 'id',
        },
        {
          text: i18n.t('screener.table.header.logo'),
          align: 'center',
          value: 'logo_url',
        },
        {
          text: i18n.t('screener.table.header.title'),
          align: 'left',
          sortable: false,
          value: 'title',
        },
        {
          text: 'Event Type',
          align: 'left',
          sortable: false,
          value: 'event_type',
        },
        {
          text: this.$t('screener.overview.event_plan_type'),
          align: 'left',
          sortable: true,
          value: 'screening_type',
        },
        {
          text: i18n.t('screener.table.header.media_title'),
          align: 'left',
          sortable: false,
          value: 'film',
        },
        {
          text: i18n.t('screener.table.header.virtual_seats'),
          sortable: false,
          value: 'seats',
        },
        {
          text: i18n.t('screener.table.header.venue_seats'),
          sortable: false,
          value: 'venue_total_seats',
        },
        {
          text: i18n.t('screener.table.header.start_end_date'),
          sortable: false,
          value: 'start_ends_date',
        },

        {
          text: i18n.t('screener.table.header.tolerance'),
          sortable: false,
          value: 'tolerance',
        },

        {
          text: i18n.t('screener.table.header.status'),
          align: 'left',
          sortable: false,
          value: 'published',
        },
        {
          text: i18n.t('screener.table.header.created_at'),
          sortable: false,
          value: 'created_at',
        },
        {
          text: i18n.t('screener.table.header.action'),
          align: 'center',
          sortable: false,
          value: 'action',
        },
      ],
      eventTypes:[
        {
          text:'All',
          value:[]
        },
        {
          text:i18n.t('defines.screener_type_str.virtual'),
          value:[DEFINES.SCREENER_TYPE.VIRTUAL]
        },
        {
          text:i18n.t('defines.screener_type_str.physical'),
          value:[DEFINES.SCREENER_TYPE.PHYSICAL]
        },
        {
          text:i18n.t('defines.screener_type_str.virtual_and_physical'),
          value:[DEFINES.SCREENER_TYPE.VIRTUAL_AND_PHYSICAL]
        }
      ],
      pagination: {sortBy: 'created_at', rowsPerPage: 30},
      deleteScreenerId: null,
      screening_type: null,
      elaborateEventDialogue:false
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getApiData();
      },
      deep: true,
    },
    '$route.query': {
      handler(newQuery, oldQuery) {
        console.log('Route query changed', newQuery)
        this.handleQueryChange(newQuery, oldQuery);
      },
      deep: true,
      immediate: true
    }
  },
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
     vm.getApiData();
    });
  },

  created() {
    this.getApiData();
  },
  computed: {
    ...mapState({
      list: (state) => state.screener.list,
      filmCount: (state) => state.film.list.length,
    }),
    ...mapGetters('company', {
      timezone: 'getSelectedCompanyTimezone',
      selected_company: "getSelectedCompany"
    }),
    ...mapGetters('screener', {
      isScreeningPaid: 'isScreeningPaid',
    }),
    isDebugMode() {
      return this.$route.query.debug
    },
  },
  components: {ConfirmationDialog, CreateScreener},
  methods: {
    async copyRegistrationUrl(screener_id) {
      this.$copyText(this.registrationLink(screener_id));
      this.$store.dispatch("app/showMessage", {
        message: "URL copied successfully",
        color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
      });
    },
    registrationLink(screener_id) {
      if (this.selected_company && screener_id) {
        return `${this.selected_company.domain}/screeners/${screener_id}`;
      }
    },
    async getApiData(resetPagination = false) {
      this.loading = true;
      if (resetPagination) {
        this.pagination.page = 1;
      }
      const {sortBy, descending, page, rowsPerPage} = this.pagination;
      try {
        var response = await this.$store.dispatch('screener/list', {
          is_vod_event: this.is_vod_event,
          page: page,
          perPage: rowsPerPage,
          schedule_type: this.schedule_type,
          screening_type: this.screening_type,
          event_types: this.event_types,
          search: this.search,
        });
        this.total = response.screeners.total;
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
      this.loading = false;
    },

    // convert utc to comapny timezone
    fmtTime(input) {
      return utcToTz(input, this.timezone, 'MMMM Do YYYY, h:mm a');
    },

    async remove() {
      try {
        await this.$store.dispatch('screener/delete', {
          screener_id: this.deleteScreenerId,
        });
        this.getApiData();
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      } finally {
        this.confirmation = false;
      }
    },

    deleteConfirmation(screener_id) {
      this.deleteScreenerId = screener_id;
      this.confirmation = true;
    },
    viewScreener(screener) {
      try {
        this.$router.push({
          name: screener.is_vod_event ?'vod.save' : 'screener.save',
          params: {
            screener_id: screener.id,
          },
          query: screener.is_vod_event ?{isVodEvent: true} :null
        });
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
    handleQueryChange(newQuery, oldQuery) {
      console.log('Handel query change --->>>>', newQuery)
      if (this.$route.name === 'vod.list') {
        this.is_vod_event = true
      }
      if ('createvent' in newQuery && newQuery.createvent === 'elaborate') {
        this.elaborateEventDialogue = true
      } else {
        this.elaborateEventDialogue = false
      }

    }
  },
};
</script>
